import { createGlobalStyle } from "styled-components";

interface StyleProps {
  deviceType?: string;
}

export const CurrencyCityStyle = createGlobalStyle<StyleProps>`

/* Background color classes */
.bg-light-grey {
  background-color: #F2F2F2;
  padding: 0px;
}

/* Desktop styles for lg deviceType */
${(props) =>
  props.deviceType === "lg"
    ? `
    @media (min-width: 1024px) {
      /* Top banner section styling for lg deviceType */
      #top-banner {
          background: url(//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/bg6.jpg) !important;
          background-repeat: no-repeat !important;
          padding-bottom: 40px !important;
          min-height: auto !important;
          padding: 0 !important;
          margin: 0 !important;
      }

      /* Top banner container styles */
      .top-banner__container {
          margin: 0 auto !important;
          padding-top: 32px !important;
          max-width: 1200px !important;
      }

      .top-banner__wrapper {
          padding-bottom: 40px;
          padding-top: 16px;
      }

      .top-banner__title {
          font-size: 36px !important;
          line-height: 43.2px !important; /* 1.2em of 36px */
          font-weight: 900 !important;
          color: #FFFFFF !important;
          margin: 0 !important;
      }

      .top-banner__description {
          color: white;
          margin-top: 8px;
          font-weight: 700;
          line-height: 24px;
          margin-bottom: 0;
          font-size: 16px;
      }

      .top-banner__breadcrumb {
          margin-top: 16px !important;
      }

      /* Header styling for lg deviceType */
      header {
          position: sticky !important;
          top: 0 !important;
          z-index: 10 !important;
          background-color: #fff !important;
          padding: 18px 0 !important;
      }

      /* Remove negative margins for lg deviceType */
      .container.negativeMargin {
          margin-top: 0 !important;
      }

      .pageContainer.pageContainer_margin {
          margin-top: 0 !important;
      }

      /* Section wrapper styling for lg deviceType */
      .sectionWrapper {
          background-color: #fff;
          border-radius: 16px;
          padding: 32px 24px;
          margin-bottom: 48px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
      
      .sectionWrapper:last-child {
          margin-bottom: 0;
      }

      /* Typography improvements for lg deviceType */
      .tripMoneySection h2 {
          font-size: 22px !important;
          line-height: 26.4px !important;
          font-weight: 900 !important;
          color: #000 !important;
          margin-bottom: 16px !important;
      }

      .tripMoneySection h3 {
          font-size: 18px !important;
          line-height: 21.6px !important;
          font-weight: 700 !important;
          color: #000 !important;
          margin-bottom: 12px !important;
      }

      .tripMoneySection p,
      .tripMoneySection .description {
          font-size: 16px !important;
          line-height: 19.2px !important;
          font-weight: 400 !important;
          color: #4A4A4A !important;
      }

      .container {
        max-width: 1200px;
        width: 1200px !important;
        margin: 0 auto;
        padding: 24px 0px;
      }

      /* Container card improvements */
      .container__card {
          background-color: #fff;
          border-radius: 8px;
          padding: 0px;
          box-shadow: none;
          margin-bottom: 16px;
      }

      .tripmoneyImgWrap::after {
          content: '';
          position: absolute;
          top: -100px;
          right: -33px;
          width: 1px;
          height: 235px;
          background: none !important;
          border: 1px dashed #d5d5d5;      
      }

      .container__card.container__cardAlign {
          border: 1px solid #D8D8D8 !important;
          border-radius: 8px !important;
          padding: 16px 8px !important;
      }

      /* Hide separators on desktop by default */
      .separator {
          display: none !important;
      }

      .sectionWrapper .separator {
          display: none !important;
      }

      /* Hide containerImg for lg deviceType */
      .containerImg {
          display: none !important;
      }

      /* FAQ section styles for lg deviceType */
      .faqList {
          margin-top: 16px !important;
      }

      .faqList li h4.question {
          font-size: 16px !important;
          line-height: 16px !important;
          padding: 12px 0px !important;
          font-weight: 400 !important;
      }

      .faqList li h4.question::after {
          top: 12px !important;
      }

      .faqList li:hover {
          box-shadow: none !important;
          border-color: transparent !important;
          background-color: transparent !important;
      }

      .faqList li:hover h4.question {
          background-color: transparent !important;
          box-shadow: none !important;
          border-radius: none !important;
      }

      .faqList li div.answer {
          font-size: 14px !important;
          margin-bottom: 16px !important;
      }

      /* Currency Converter styling for lg deviceType */
      .sectionWrapper .h2 {
          font-size: 22px !important;
          line-height: 26.4px !important;
          font-weight: 900 !important;
          color: #000 !important;
          margin-bottom: 24px !important;
      }

      .sectionWrapper .capSulesList {
          display: grid !important;
          grid-template-columns: repeat(4, 1fr) !important;
          gap: 16px !important;
          margin-bottom: 24px !important;
          list-style: none !important;
          padding: 0 !important;
      }

      .sectionWrapper .capSulesList li {
          box-shadow: none !important;
      }

      .sectionWrapper .capSulesList.grid5 {
          grid-template-columns: repeat(4, 1fr) !important;
      }

      .sectionWrapper .capsule {
          background-color: #F0F0F0 !important;
          border-radius: 5px !important;
          padding: 12px 16px !important;
          text-align: center !important;
          min-height: 40px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          border: 1px solid #E0E0E0 !important;
      }

      .sectionWrapper .capSulesList:not(.showAll) .capsule:nth-child(n+5) {
          display: none !important;
      }

      .sectionWrapper .capSulesList.grid5:not(.showAll) .capsule:nth-child(n+5) {
          display: none !important;
      }

      .sectionWrapper .capsule a {
          color: #008CFF!important;
          text-decoration: none !important;
          font-size: 14px !important;
          font-weight: 900 !important;
          line-height: 16.8px !important;
          display: block !important;
          width: 100% !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
      }

      .sectionWrapper .viewMore {
          text-align: left !important;
          margin-top: 24px !important;
          margin-bottom: 0 !important;
      }

      .sectionWrapper .viewMore__cta {
          color: #008CFF !important;
          text-decoration: none !important;
          font-size: 16px !important;
          font-weight: 700 !important;
          cursor: pointer !important;
          padding: 8px 16px !important;
          border-radius: 6px !important;
          transition: all 0.2s ease !important;
          display: inline-block !important;
          background-color: transparent !important;
          border: none !important;
      }

      /* Exchange Rate Wrap section styling for lg deviceType */
      .exchangeRateWrap {
          display: flex !important;
          gap: 24px !important;
          align-items: flex-start !important;
      }

      .exchangeRateWrap .container__card.flexOne {
          flex: 1 1 50% !important;
          max-width: 50% !important;
          margin-right: 0 !important;
      }

      .exchangeRateWrap .flexOne.makeFlex.column {
          flex: 1 1 50% !important;
          max-width: 50% !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 24px !important;
      }

      .exchangeRateWrap .flexOne.makeFlex.column .container__card {
          margin-bottom: 0 !important;
      }

      /* Identification/Fake Currency section styling */
      .identification-wrapper {
          background-color: #fff;
          border-radius: 16px;
          padding: 32px 24px;
          margin-bottom: 24px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      .identification-section .tripMoneySection.makeFlex {
          display: flex !important;
          gap: 32px !important;
          align-items: flex-start !important;
          justify-content: space-between !important;
      }

      .identification-section .tripMoneySection.makeFlex > div:first-child {
        //   flex: 1 1 auto !important;
        //   max-width: calc(100% - 320px) !important;
        //   padding-right: 16px !important;
      }

      .identification-section .tripMoneySection.makeFlex > div:last-child {
        //   flex: 0 0 auto !important;
        //   width: 280px !important;
      }

      .identification-section .counterFietImgWrapMweb {
          display: none !important;
      }

      .identification-section ul {
          max-width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          list-style: none !important;
      }

      .identification-section ul li {
          font-size: 16px !important;
          line-height: 24px !important;
          font-weight: 400 !important;
          color: #333333 !important;
          margin-bottom: 12px !important;
          padding-bottom: 0 !important;
          border-bottom: none !important;
      }

      .identification-section ul li:last-child {
          margin-bottom: 0 !important;
      }

      .identification-section ul li.makeFlex {
          display: flex !important;
          align-items: flex-start !important;
          gap: 12px !important;
      }

      .identification-section ul li span {
          flex: 1 !important;
          font-size: 16px !important;
          line-height: 24px !important;
          font-weight: 400 !important;
          color: #333333 !important;
      }

      .identification-section .greenCheckImg {
          width: 16px !important;
          height: 16px !important;
          margin-right: 0 !important;
          flex-shrink: 0 !important;
      }

      .identification-section .counterFietImgWrap {
          display: flex !important;
          align-items: flex-start !important;
          justify-content: center !important;
          height: auto;
          width: 220px !important;
      }

      .identification-section .counterFietImgWrap img {
          max-width: 100% !important;
          height: auto !important;
          object-fit: contain !important;
          border-radius: 8px !important;
      }

      /* Product Range List styling */
      .productRangeList li {
          border-bottom: none !important;
          padding: 8px 0 !important;
          font-size: 14px !important;
          line-height: 20px !important;
          color: #333333 !important;
      }

      /* Step count styling */
      .tripMoneySection__bestRateBuy li {
          width: auto !important;
          margin-bottom: 16px !important;
          background-size: 370px 94px;
      }

      /* Document list styling */
      .documentList li {
          display: flex !important;
          align-items: flex-start !important;
          gap: 12px !important;
          margin-bottom: 12px !important;
          font-size: 14px !important;
          line-height: 20px !important;
          color: #333333 !important;
      }

      .documentList .greenCheckImg {
          width: 16px !important;
          height: 16px !important;
          flex-shrink: 0 !important;
      }

      /* Remove padding-bottom and border-bottom from tripMoneySection for lg deviceType */
      .tripMoneySection {
          padding-bottom: 0 !important;
          border-bottom: none !important;
      }

      /* Add position relative for list items with rectangular icons for lg deviceType */
      .tripMoneySection li.makeFlex.appendBottom15 {
          position: relative !important;
          padding: 0px 0px 9px 25px !important;
      }

      /* Add rectangular icon before list items as per Figma design for lg deviceType */
      .tripMoneySection li.makeFlex.appendBottom15::before {
        content: "";
        width: 7px;
        height: 15px;
        border-radius: 4px;
        background-image: linear-gradient(to bottom, #16477F, #16477F) !important;
        position: absolute;
        left: 0;
        top: 3px;
      }

      /* Hide green check images for lg deviceType to match Figma design */
      .tripMoneySection .greenCheckImg {
          display: none !important;
      }

      /* Add position relative and padding for productRangeList items for lg deviceType */
      .productRangeList li {
          position: relative !important;
          padding: 0px 0px 9px 25px !important;
          list-style: none !important;
      }

      /* Add rectangular icon before productRangeList items as per Figma design for lg deviceType */
      .productRangeList li::before {
          content: "";
          width: 7px;
          height: 15px;
          border-radius: 4px;
          background-image: linear-gradient(to bottom, #16477F, #16477F) !important;
          position: absolute;
          left: 0;
          top: 3px;
      }

      /* Remove default list styling for productRangeList for lg deviceType */
      .productRangeList {
          padding-left: 0 !important;
      }

      /* Add margin-bottom to sections wrapper for lg deviceType */
      .sections-wrapper-lg {
          padding-bottom: 80px !important;
          background-color: #F2F2F2 !important;
      }

      /* Hide the default ::after bullet points for productRangeList for lg deviceType */
      .productRangeList li::after {
          display: none !important;
      }
    }
  `
    : ""}
`;
